// extracted by mini-css-extract-plugin
export default {"actions":"delete-modal_actions__65bdf"};